module.exports = __webpack_public_path__ + "static/media/encuentro-sitio-aparicion-500.b341120d.jpg";